<template>
  <div class="container">
    <div :class="{ banner: true, showBtn: btnFlage }">
      <div class="swiper-container bannerSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in bannerList"
            :key="index + 'qua'"
          >
            <img :src="item.photo" width="100%" height="auto" />
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-next"></div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-pagination"></div>
        <!--分页器。如果放置在swiper外面，需要自定义样式。-->
      </div>
    </div>

    <!-- 第一部分系统特色 -->
    <div class="solve_page_one_side">
      <div class="solve_system_title" id="title">系统特色</div>
      <div class="solve_system_content">
        <p>{{ solveForm.trait }}</p>
      </div>

      <!-- 卡片说明部分 -->
      <div class="solve_system_card">
        <div
          :class="{ solve_card_item: true, selectIn: selectFlages[0] }"
          @mouseenter="selectIn(0)"
          @mouseleave="selectOut(0)"
        >
          <div :class="{ card_item_img: true }">
            <img :src="require('../../assets/yunthee/' + imgList[0])" />
          </div>
          <div class="card_item_title">物联网中台</div>
          <div class="card_item_tag"></div>
          <div class="card_item_content">
            <p>兼容多协议、多数据库，轻松接入不同厂家不同设备。</p>
          </div>
        </div>

        <div
          :class="{ solve_card_item: true, selectIn: selectFlages[1] }"
          @mouseenter="selectIn(1)"
          @mouseleave="selectOut(1)"
        >
          <div
            :class="{ card_item_img: true }"
            style="width: 65px; height: 57px"
          >
            <img :src="require('../../assets/yunthee/' + imgList[1])" />
          </div>
          <div class="card_item_title">数据可视化</div>
          <div class="card_item_tag"></div>
          <div class="card_item_content">
            <p>2D、3D模型，一张图，折线图，饼状图，柱状图，圆环图</p>
          </div>
        </div>

        <div
          :class="{ solve_card_item: true, selectIn: selectFlages[2] }"
          @mouseenter="selectIn(2)"
          @mouseleave="selectOut(2)"
        >
          <div
            :class="{ card_item_img: true }"
            style="width: 45px; height: 60px"
          >
            <img :src="require('../../assets/yunthee/' + imgList[2])" />
          </div>
          <div class="card_item_title">AI算法支持</div>
          <div class="card_item_tag"></div>
          <div class="card_item_content">
            <p>数据清洗、数值模拟、预测分析</p>
          </div>
        </div>

        <div
          :class="{ solve_card_item: true, selectIn: selectFlages[3] }"
          @mouseenter="selectIn(3)"
          @mouseleave="selectOut(3)"
        >
          <div
            :class="{ card_item_img: true }"
            style="width: 59px; height: 53px"
          >
            <img :src="require('../../assets/yunthee/' + imgList[3])" />
          </div>
          <div class="card_item_title">业务协同</div>
          <div class="card_item_tag"></div>
          <div class="card_item_content">
            <p>围绕人、机、法、料、环，搭建一体化业务系统</p>
          </div>
        </div>
      </div>

      <!-- 系统功能与应用 -->
      <div class="solve_system_def_title" id="title">系统功能与应用</div>

      <!-- 富文本部分 -->
      <div class="solve_system_editor_main">
        <div class="editor_main_title_tag"></div>
        <div class="editor_main_title">
          {{ solveForm.title }}
        </div>
        <div class="editor_main_content" v-html="solveForm.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import { getSolveOne, getSolveList, getBanner } from '@/api/apiCenter'
export default {
  data() {
    return {
      bannerSwiper: undefined,
      bannerList: [],
      btnFlage: false,
      solveList: [],
      solveForm: {},
      selectFlages: [false, false, false, false],
      imgList: [
        'solve_item_img_01.png',
        'solve_item_img_02.png',
        'solve_item_img_03.png',
        'solve_item_img_04.png',
      ],
    }
  },
  methods: {
    initBannerSwiper() {
      this.bannerSwiper = new Swiper('.bannerSwiper', {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 500,
        freeMode: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    },
    init() {
      let that = this
      // axios
      //   .get('http://www.thingo.com.cn/thingo-server/website/homePage/banner')
      //   .then((res) => {
      //     that.bannerList = res.data.data

      //     this.$nextTick(() => {
      //       this.initBannerSwiper()
      //       this.getSolveList()
      //     })
      //   })
      getBanner('solution').then((res) => {
        that.bannerList = res.data.data
        this.$nextTick(() => {
          this.initBannerSwiper()
          this.getSolveList()
        })
      })
    },
    getSolvePage() {
      let sid = this.$route.query.sid
      console.log(sid)
      getSolveOne(sid).then((res) => {
        console.log('路由单个查询', res)
        this.solveForm = res.data.data
      })
    },
    getSolveList() {
      getSolveList().then((res) => {
        this.solveList = res.data.data
        let sid = this.solveList[0].id
        getSolveOne(sid).then((res) => {
          this.solveForm = res.data.data
        })
      })
    },
    mountBusList() {
      this.$EventBus.$on('routerQuerySolve', () => {
        this.getSolvePage()
      })
    },
    uninstallBusList() {
      this.$EventBus.$off('routerQuerySolve')
    },
    selectIn(index) {
      let imgIndex = index + 1
      let imgUrl = 'solve_item_img_0' + (imgIndex + 4) + '.png'
      this.selectFlages[index] = true
      this.imgList[index] = imgUrl
      this.$forceUpdate()
    },
    selectOut(index) {
      let imgIndex = index + 1
      let imgUrl = 'solve_item_img_0' + imgIndex + '.png'
      this.selectFlages[index] = false
      this.imgList[index] = imgUrl
      this.$forceUpdate()
    },
  },
  mounted() {
    this.init()
    this.mountBusList()
  },
  beforeDestroy() {
    this.uninstallBusList()
  },
}
</script>
<style scoped>
/* 轮播部分 */
.banner .swiper-container {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper .swiper-slide {
  width: 100%;
  height: auto;
}
.banner .swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: rgba(161, 161, 161, 0.5); /* 单独设置按钮颜色 */
  --swiper-navigation-size: 50px; /* 设置按钮大小 */
  --swiper-pagination-color: rgba(255, 255, 255, 0.5); /* 两种都可以 */
  --swiper-pagination-size: 50px; /* 设置按钮大小 */
}

/* 第一部分系统特色 */
.solve_page_one_side {
  width: 100%;
  height: auto;
  padding-bottom: 300px;
}
.solve_system_title {
  width: 50%;
  height: 50px;
  margin: 50px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.solve_system_content {
  width: 100%;
  height: auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.solve_system_content p {
  margin: 0;
  display: inline-block;
  max-width: 70%;
  height: auto;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #707e8f;
  line-height: 24px;
}

/* 卡片说明部分 */
.solve_system_card {
  width: 70%;
  height: auto;
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.solve_card_item {
  width: 23%;
  height: 424px;
  cursor: pointer;
}
.card_item_img {
  width: 58px;
  height: 58px;
  margin: 50px auto 0 auto;
}
.card_item_img img {
  width: 100%;
  height: 100%;
}
.card_item_title {
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 50px;
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 48px;
}
.card_item_tag {
  width: 4px;
  height: 24px;
  margin: 20px auto 0 auto;
  background-color: #2468f2;
}
.card_item_content {
  width: 100%;
  height: auto;
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.card_item_content p {
  margin: 0;
  display: inline-block;
  max-width: 80%;
  height: auto;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #6f7d8e;
  line-height: 25px;
}
.selectIn {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 3px 20px 0px rgba(109, 210, 255, 0.16);
}

/* 系统功能与应用 */
.solve_system_def_title {
  width: 50%;
  height: 50px;
  margin: 153px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}

/* 富文本部分 */
.solve_system_editor_main {
  width: 70%;
  height: auto;
  margin: 50px auto 0 auto;
}
.editor_main_title_tag {
  width: 50px;
  height: 4px;
  background-color: #2468f2;
}
.editor_main_title {
  width: 100%;
  height: auto;
  margin-top: 20px;
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 48px;
}
.editor_main_content {
  width: 100%;
  height: auto;
  margin-top: 50px;
}
</style>
<style>
.editor_main_content p {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #6f7d8e;
  line-height: 50px;
}
.editor_main_content img {
  width: 70%;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style>
